
export enum AuthenticationFederationType {
  WsFed = 1,
  Saml = 2
}
